<template>
  <div>NotificacionesReactivar</div>
</template>
<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component
export class NotificacionesReactivar extends Vue {}
export default NotificacionesReactivar;
</script>
